import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PORTAL_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('PORTALS');
export const PORTAL_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PORTAL_CRUD_ACTION_CONSTANTS
);
